var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"future-charts"},[_c('ve-line',{attrs:{"data":_vm.chartData,"settings":_vm.settings,"mark-line":_vm.markLine,"mark-point":_vm.markPoint,"extend":_vm.extend,"toolbox":_vm.toolbox,"grid":_vm.grid,"xAxis":_vm.xAxis,"colors":_vm.chartColors}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }